import React, { useState } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import { withTranslation } from "react-i18next";
import { connect, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";

import user1 from "../../../assets/images/users/user.png";
import { formatUserName } from "../../../helpers/formatUserName";

const ProfileMenu = props => {
  const [menu, setMenu] = useState(false);

  const { user: loggedUser } = useSelector(state => state.Login);

  const roleLabel =
    Number(loggedUser?.role) === 1
      ? "Super Admin"
      : Number(loggedUser?.role) === 2
        ? "Admin"
        : "User";
  const displayName =
    formatUserName({
      firstName: loggedUser?.firstName,
      lastName: loggedUser?.lastName,
    }) || roleLabel;

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <div className="d-flex align-items-center justify-content-end">
          {!props.compact && (
              <>
                <span className="d-none d-xl-inline-block ms-2 w-100 text-end" style={{marginTop: "-10px", color: "#5DA9DD"}}>
                  <br /> {displayName}
                  <span className="d-none d-xl-inline-block w-100 text-end">{loggedUser?.email}</span>
                </span>
                <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
              </>
            )}
            
            <img
              className="rounded-circle header-profile-user mt-1"
              src={user1}
              alt="Header Avatar"
            />
            
          </div>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {/* <DropdownItem tag="a" href="/profile">
            {" "}
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Profile")}{" "}
          </DropdownItem> */}
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
  compact: PropTypes.bool
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
